export default __webpack_public_path__ + "1492738e6604e26c0c67c033f2026e27.svg";